import {
    AfterViewInit, Directive, ElementRef, OnInit,
    Renderer
} from '@angular/core';

@Directive({
    'selector': '[autofocus]'
})
export class AutofocusDirective implements OnInit, AfterViewInit {
    constructor(
        private el: ElementRef,
        private renderer: Renderer
    ) {}

    ngOnInit() {}
    ngAfterViewInit() {
        this.renderer.invokeElementMethod(this.el.nativeElement, 'focus', []);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2032928750/src/src/app/shared/directives/autofocus.directive.ts